module.exports = __webpack_public_path__ + "static/media/Blokes-avatar-Nima-transparent.ecd05919.png";